/**
 * @desc 导出箱单发票
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.cabinMasterSelfScattered.exportBoxingBill.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMasterSelfScattered/exportBoxingBill`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
